/* Strictly allowlisted replay adapter; never forwards commerce payloads or IDs. */
(() => {
  'use strict';
  const root = document.getElementById('strx-clarity-config');
  if (!root || !window.strxPrivacy) return;
  let config;
  try { config = JSON.parse(root.textContent); } catch (_) { return; }
  if (!config || typeof config !== 'object' || typeof config.projectId !== 'string'
      || !/^[a-z0-9]{10}$/.test(config.projectId) || config.projectId.length !== 10) return;
  // Keep in step with ClarityPolicy.PageType. No authentication callback,
  // reset/verification link, payment return, admin or arbitrary route is allowed.
  const safePath = /^\/(en|ar)(\/?|\/(shop|brands|cart|checkout|about|privacy|terms|refund|shipping|faq|contact)\/?|\/(products|category|brands)\/[a-z0-9-]+\/?|\/account\/(login|register|profile|addresses(\/add|\/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}\/(edit|delete))?)\/?|\/(account\/orders(\/SX-[0-9]{4}-[0-9]{6,})?|orders\/track|checkout\/confirmation\/SX-[0-9]{4}-[0-9]{6,})\/?)$/i;
  function safeUrl(raw) {
    if (!raw) return true;
    try {
      const url = new URL(raw);
      return url.origin === location.origin && !url.search && !url.hash && safePath.test(url.pathname);
    } catch (_) { return false; }
  }
  if (!safeUrl(location.href) || !safeUrl(document.referrer)) return;
  if (document.body.getAttribute('data-clarity-mask') !== 'true') return;

  let active = false;
  const pageEvents = new Set();
  const allowed = { view_item_list: 'strx_catalog_view', view_item: 'strx_product_view', add_to_cart: 'strx_cart_add', view_cart: 'strx_cart_view', checkout_intent: 'strx_checkout_intent' };
  function start() {
    const preferences = window.strxPrivacy.read();
    if (active || window.__strxClarityRequested || window.__strxTrackingStopped || !preferences.analytics) return;
    active = true;
    window.clarity = window.clarity || function () {
      const queue = window.clarity.q = window.clarity.q || [];
      if (queue.length < 128) queue.push(arguments);
    };
    window.clarity('consentv2', { analytics_Storage: 'granted', ad_Storage: preferences.advertising ? 'granted' : 'denied' });
    window.clarity('set', 'strx_locale', config.locale === 'ar' ? 'ar' : 'en');
    if (['home','catalog','product','cart','information','checkout','account','order'].includes(config.pageType)) window.clarity('set', 'strx_page_type', config.pageType);
    if (/^[a-zA-Z0-9._-]{1,64}$/.test(config.release || '')) window.clarity('set', 'strx_release', config.release);
    window.__strxClarityRequested = true;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.clarity.ms/tag/' + config.projectId;
    script.addEventListener('error', () => {
      active = false;
      if (window.clarity?.q) window.clarity.q.length = 0;
    }, { once: true });
    document.head.appendChild(script);
  }
  window.__strxStopClarity = (withdrawal = true) => {
    active = false;
    pageEvents.clear();
    // privacy.js installs enforcing CSP before entering this callback.
    if (window.clarity?.q) window.clarity.q.length = 0;
    try {
      if (withdrawal) window.clarity?.('consentv2', { analytics_Storage: 'denied', ad_Storage: 'denied' });
      window.clarity?.('stop');
    } catch (_) { /* no retry */ }
  };
  window.__strxClarityEvent = name => {
    const eventName = Object.hasOwn(allowed, name) ? allowed[name]
      : window.strxInteraction?.names.includes(name) ? name : null;
    if (!active || !window.strxPrivacy.allows('analytics') || !eventName) return;
    if (name === 'view_item' || name === 'view_item_list') {
      if (pageEvents.has(name)) return;
      pageEvents.add(name);
    }
    try { window.clarity('event', eventName); } catch (_) { /* never interrupt shopping */ }
  };
  start();
  // analytics.js may run before this deferred adapter. Reuse only current-page
  // names; do not retain/replay historical interaction payloads.
  if (active) document.querySelectorAll('script.strx-ga4-event').forEach(island => {
    const name = island.getAttribute('data-strx-event');
    if (island.dataset.strxFired === 'true' && ['view_item', 'view_item_list', 'view_cart'].includes(name)) window.__strxClarityEvent(name);
  });
  document.addEventListener('strx:consent-changed', start);
  // Fragments may contain private values, so changing one stops capture.
  // No free text is copied into attributes by the search overlay.
  window.addEventListener('hashchange', () => window.strxPrivacy.barrier(true));
})();
